import React from 'react';
import { useTranslation } from 'react-i18next';
import BankIDAuth from '../bank-id-auth';

/**
 * Inline BankID component for the sign-up page.
 * Renders as an in-page card with no overlay/modal backdrop.
 * Intentionally separate from BankIDAuth usage in create-invoice.page.tsx.
 */

interface BankIDSignupInlineProps {
    accountType: 'freelancer' | 'business';
    onSuccess?: (userData: any) => void;
}

const BankIDSignupInline: React.FC<BankIDSignupInlineProps> = ({ accountType, onSuccess }) => {
    const { t } = useTranslation();

    return (
        <BankIDAuth
            mode="signup"
            accountType={accountType}
            className="bankid-signup-inline"
            showCloseButton={false}
            onSuccess={onSuccess}
            title={t('SIGNING_UP_WITH_BANK_ID')}
            autoInitialize={false}
            skipSameDevicePolling={true}
            autoReloadOnExpiry={true}
        />
    );
};

export default BankIDSignupInline;
